module.exports = __webpack_public_path__ + "img/qty.a28ec08b.png";